import { useEffect } from "react";
import { useTranslation } from "react-i18next";

import { useGetProfile } from "@/entities/current-user";
import { useAuthContext } from "@/services/auth";
import { setDayJsLocale } from "@/services/dayjs";

import { handleFallbackAppLocale } from "./language.helper";

export const useLanguageHandler = () => {
  const { i18n } = useTranslation();
  const { hasToken } = useAuthContext();
  const { profile, isLoading } = useGetProfile({ enabled: hasToken });

  useEffect(() => {
    if (!isLoading && profile?.locale) {
      // On user locale change, uopdate i18n & dayjs
      i18n.changeLanguage(profile.locale);
      setDayJsLocale(profile.locale);
    }
  }, [isLoading, profile]);
};

export const useAppLocale = () => {
  const { i18n } = useTranslation();

  return handleFallbackAppLocale(i18n.language);
};
